<template>
  <div class="choose-scheduled-ride-type">
    <h6 class="sub-section-title">
      Schedule Ride Type
    </h6>

    <div class="row align-items-center">
      <label class="col-sm-3 control-label"> Ride Type </label>
      <div class="col-sm-8 pr-0">
        <p-button
          v-for="[kind, text] in scheduleKinds"
          :key="kind"
          :type="modelValue === kind ? 'purple' : 'primary'"
          round
          :disabled="!isKindAllowed(kind)"
          :pressed="modelValue === kind"
          @click="emit('update:modelValue', kind)"
        >
          <span
            v-if="modelValue === kind"
            class="btn-label"
          >
            <i class="fa fa-check" />
          </span>
          {{ text }}
        </p-button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { meOperator } from '@/services/operators/viewModel'
import { useCustomer } from '@/use/customer'
import { useProfile } from '@/use/profile'
import { computed, type ComputedRef } from 'vue'

const { customerInfo } = useCustomer()
const { userRoles } = useProfile()

const props = defineProps({
  modelValue: {
    type: String,
    required: true,
  },

  scheduledRideId: {
    type: Number,
    default: 0,
  },

  disabled: {
    type: Boolean,
    default: false,
  },

  appointmentAllowed: {
    type: Boolean,
    default: true,
  },

  willcallAllowed: {
    type: Boolean,
    default: true,
  }
});

const scheduleKinds: ComputedRef<[string, string][]> = computed(() => {
  const list = [['single', 'SINGLE RIDE'], ['multi', 'REPEATED RIDE'], ['appointment', 'APPOINTMENT']] as [string, string][];

  const isWillCall = props.modelValue === 'willcall'
  const allowWillCallRides = customerInfo.value?.partner?.config?.allowWillCallRides;
  if (isWillCall || (allowWillCallRides && (meOperator.value || userRoles.isPartnerAdmin))) {
    list.push(['willcall', 'WILL CALL'] as [string, string])
  }

  return list;
})

const isKindAllowed = (kind: string) => {
  if (props.disabled) {
    return false;
  }

  if (!props.appointmentAllowed && kind === 'appointment') {
    return false;
  }

  if (!props.willcallAllowed && kind === 'willcall') {
    return false;
  }

  if (!props.scheduledRideId) {
    return true;
  }

  if (props.modelValue === 'multi') {
    return false;
  }

  // allow switching single/appointment only
  return ['single', 'appointment'].includes(kind)
}

const emit = defineEmits(['update:modelValue'])
</script>
